import {
    Invoice_DownloadInvoiceURL as download
} from "./backend"
import axios from 'axios'

const forceFileDownload = (response, pdfName) => {
    const url = window.URL.createObjectURL(new Blob([response.data]))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', `Invoice_${pdfName}.pdf`)
    document.body.appendChild(link)
    link.click()
}


const downloadInvoice = async (id, key, invoiceNumber) => {
    const url = download({
        id: id,
        key: key,
        invoiceNumber: invoiceNumber
    });
    const response = await axios({
        method: 'get',
        url: url,
        responseType: 'arraybuffer'
    });
    try {
        forceFileDownload(response, invoiceNumber);
    } catch(err){
        window.open(url);
    }
}

export default {
    downloadInvoice
}